import React from "react";
import { AbsoluteFill } from "remotion";
import { ZuraCubeBot } from "./components/ZuraCubeBot";
import { Sparkles, Terminal, Coffee, Layers } from "lucide-react";

export const ZuraMascotPreview: React.FC = () => {
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#F4F1EA",
        color: "#1C1917",
        fontFamily: "'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "140px 60px 120px",
        boxSizing: "border-box",
      }}
    >
      {/* Background Dot Grid */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "radial-gradient(circle, rgba(28, 25, 23, 0.08) 1.5px, transparent 1.5px)",
          backgroundSize: "32px 32px",
          pointerEvents: "none",
        }}
      />

      {/* Header Pill */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          zIndex: 10,
        }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "2.5px solid #1C1917",
            borderRadius: 999,
            padding: "10px 28px",
            boxShadow: "4px 4px 0px #1C1917",
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span
            style={{
              fontFamily: "'Space Grotesk', monospace",
              fontWeight: 900,
              color: "#00F0FF",
              fontSize: 22,
            }}
          >
            &#123;Z&#125;
          </span>
          <span
            style={{
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: 22,
              fontWeight: 800,
              letterSpacing: 2,
              color: "#1C1917",
              textTransform: "uppercase",
            }}
          >
            COLOR PALETTE EXPLORATION · BENTO CUBE
          </span>
        </div>

        <h1
          style={{
            fontFamily: "'Anton', 'Bebas Neue', sans-serif",
            fontSize: 66,
            letterSpacing: 1.5,
            lineHeight: 1.0,
            color: "#1C1917",
            margin: 0,
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          4 PILIHAN WARNA NON-GELAP "ZURA BOT"
        </h1>
        <p
          style={{
            fontSize: 22,
            color: "#4B5563",
            fontWeight: 600,
            margin: 0,
            textAlign: "center",
          }}
        >
          Pilih tone bodi yang paling cocok & menyatu sama aesthetic akun lo
        </p>
      </div>

      {/* 2x2 Bento Mascot Palette Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 32,
          width: "100%",
          maxWidth: 960,
          zIndex: 10,
        }}
      >
        {/* OPTION 1: CERAMIC WHITE (RECOMMENDED) */}
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "3.5px solid #1C1917",
            borderRadius: 32,
            padding: "26px 20px 20px",
            boxShadow: "8px 8px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 14,
            position: "relative",
          }}
        >
          {/* Top Recommendation Badge */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              backgroundColor: "#EFF6FF",
              padding: "6px 16px",
              borderRadius: 999,
              border: "1.5px solid #2563EB",
            }}
          >
            <Sparkles size={18} color="#2563EB" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 18,
                fontWeight: 800,
                color: "#1E40AF",
                letterSpacing: 1,
              }}
            >
              OPSI A · CERAMIC WHITE (REKOMENDASI)
            </span>
          </div>

          <ZuraCubeBot colorway="ceramic-white" mood="idle" size={250} />

          <div style={{ textAlign: "center" }}>
            <div
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 26,
                color: "#1C1917",
                letterSpacing: 1,
              }}
            >
              CLEAN INDUSTRIAL TECH
            </div>
            <p
              style={{
                fontSize: 17,
                color: "#4B5563",
                fontWeight: 600,
                margin: "4px 0 0",
              }}
            >
              Bodi putih keramik murni + visor hitam OLED + mata cyan tajam
              (Vibe Apple / Teenage Engineering).
            </p>
          </div>
        </div>

        {/* OPTION 2: CYBER CYAN / ICE TEAL */}
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "3.5px solid #1C1917",
            borderRadius: 32,
            padding: "26px 20px 20px",
            boxShadow: "8px 8px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              backgroundColor: "#ECFDF5",
              padding: "6px 16px",
              borderRadius: 999,
              border: "1.5px solid #059669",
            }}
          >
            <Terminal size={18} color="#059669" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 18,
                fontWeight: 800,
                color: "#065F46",
                letterSpacing: 1,
              }}
            >
              OPSI B · CYBER ICE CYAN
            </span>
          </div>

          <ZuraCubeBot colorway="cyber-cyan" mood="talking" size={250} />

          <div style={{ textAlign: "center" }}>
            <div
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 26,
                color: "#0C4A6E",
                letterSpacing: 1,
              }}
            >
              BRAND ALIGNED &#123;Z&#125; GLOW
            </div>
            <p
              style={{
                fontSize: 17,
                color: "#4B5563",
                fontWeight: 600,
                margin: "4px 0 0",
              }}
            >
              Bodi sentuhan biru es pastel (#E0F2FE), senada sama warna kurung
              kurawal di logo lo.
            </p>
          </div>
        </div>

        {/* OPTION 3: RETRO BEIGE / SPACE CREAM */}
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "3.5px solid #1C1917",
            borderRadius: 32,
            padding: "26px 20px 20px",
            boxShadow: "8px 8px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              backgroundColor: "#FFF7ED",
              padding: "6px 16px",
              borderRadius: 999,
              border: "1.5px solid #EA580C",
            }}
          >
            <Coffee size={18} color="#EA580C" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 18,
                fontWeight: 800,
                color: "#9A3412",
                letterSpacing: 1,
              }}
            >
              OPSI C · RETRO MAC BEIGE
            </span>
          </div>

          <ZuraCubeBot colorway="retro-cream" mood="coffee" size={250} />

          <div style={{ textAlign: "center" }}>
            <div
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 26,
                color: "#9A3412",
                letterSpacing: 1,
              }}
            >
              VINTAGE BRAUN & GAMEBOY
            </div>
            <p
              style={{
                fontSize: 17,
                color: "#4B5563",
                fontWeight: 600,
                margin: "4px 0 0",
              }}
            >
              Bodi krem komputer 90-an (#F5EBE1) + aksen oranye industrial.
              Sangat taktil & hangat.
            </p>
          </div>
        </div>

        {/* OPTION 4: TITANIUM OBSIDIAN (ORIGINAL FOR COMPARISON) */}
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "3.5px solid #1C1917",
            borderRadius: 32,
            padding: "26px 20px 20px",
            boxShadow: "8px 8px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              backgroundColor: "#F4F4F5",
              padding: "6px 16px",
              borderRadius: 999,
              border: "1.5px solid #71717A",
            }}
          >
            <Layers size={18} color="#52525B" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 18,
                fontWeight: 800,
                color: "#27272A",
                letterSpacing: 1,
              }}
            >
              OPSI D · OBSIDIAN SLATE (LAMA)
            </span>
          </div>

          <ZuraCubeBot colorway="obsidian" mood="thinking" size={250} />

          <div style={{ textAlign: "center" }}>
            <div
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 26,
                color: "#18181B",
                letterSpacing: 1,
              }}
            >
              DARK GRAPHITE STEALTH
            </div>
            <p
              style={{
                fontSize: 17,
                color: "#4B5563",
                fontWeight: 600,
                margin: "4px 0 0",
              }}
            >
              Versi hitam gelap awal buat pembanding kontras langsung di satu
              layar.
            </p>
          </div>
        </div>
      </div>

      {/* Footer Info */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          backgroundColor: "#18181B",
          color: "#FFFFFF",
          padding: "16px 36px",
          borderRadius: 999,
          border: "2.5px solid #09090B",
          boxShadow: "6px 6px 0px #09090B",
          zIndex: 10,
        }}
      >
        <span
          style={{
            fontFamily: "'Space Grotesk', monospace",
            fontSize: 20,
            fontWeight: 800,
            color: "#00F0FF",
          }}
        >
          TIKTOK @ZURA.AILAB
        </span>
        <span style={{ color: "#71717A" }}>•</span>
        <span
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: 20,
            fontWeight: 700,
            letterSpacing: 1.5,
          }}
        >
          TENTUKAN WARNA FAVORIT LO: A, B, ATAU C?
        </span>
      </div>
    </AbsoluteFill>
  );
};
